import { createFileRoute, Link } from "@tanstack/react-router";
import { Compass, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/not-found")({
  component: NotFoundPage,
  head: () => ({
    meta: [
      { title: "Page not found — Spayzo" },
      {
        name: "description",
        content: "The page you're looking for doesn't exist or has been moved.",
      },
    ],
  }),
});

function NotFoundPage() {
  return <NotFoundView />;
}

export function NotFoundView() {
  return (
    <div className="relative min-h-screen overflow-hidden bg-background">
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(ellipse_at_bottom,_hsl(var(--primary)/0.10),_transparent_60%)]" />
      <div className="mx-auto flex min-h-screen max-w-2xl flex-col items-center justify-center px-6 py-16 text-center">
        <p className="text-[10rem] font-bold leading-none tracking-tighter text-primary/20 sm:text-[12rem]">
          404
        </p>
        <h1 className="-mt-6 text-balance text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
          This space hasn't been booked yet
        </h1>
        <p className="mt-4 max-w-md text-pretty text-base text-muted-foreground">
          The page you're looking for doesn't exist, was moved, or is currently
          unavailable. Let's get you back on track.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Button asChild>
            <Link to="/">
              <Home /> Back to home
            </Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/discover">
              <Compass /> Discover spaces
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
